(function ($) {
    $.noConflict();
    $(document).ready(function () {

           document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });
 
        // Sub-Navigation
        $('#mobile-sub-navigation-button').click(function (){
            $('.subNavigationMobile').toggle('slide', { direction: 'up' });
        });

        // Announcement Bar
        $('.announcementBar').slick({
            arrows: true,
            loop: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000
        });

        // Sticky Social Icons
        $('.sticky-social-icons-button').click(function (){
            $('.sticky-social-icons').toggleClass('open');
        });

        // Home Hero Slider
        $('.snowSlides').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 700,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
            centerMode: true
        });

         // Snow Slide Blocks
         $('.snowSlideBlocks').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            lazyLoad: 'ondemand',
            responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });  

        // Logo Carousel
        $('.logoCarouselSlide').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots:false, 
          arrows:false,
          autoplay:false,
          pauseOnHover:false,
          infinite:true,
          responsive: [
              {
                breakpoint: 960,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
          ]
        });

        $('.logoCarouselPrev').click(function() {
          $('.logoCarouselSlide').slick('slickPrev');
        });
        
        $('.logoCarouselNext').click(function() {
          $('.logoCarouselSlide').slick('slickNext');
        });

        /*
        $('.logoCarouselSlide').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots:false, 
            arrows:false,
            centerPadding: '20px',
            infinite:true,
            initialSlide: 1,
            speed: 7000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            pauseOnHover: false,
            responsive: [
                {
                  breakpoint: 960,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                  }
                },
                {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                }
            ]
        }); */

        // Image Hover Swap
        $('.logoCarouselSlide .slick-slide div').each(function() {
            if ($(this).find('img').length >= 2) {
              $(this).addClass('has-hover');
            }
        });

        // Collection Sidebar Show More 
        /*
        $(".tag-list").filter(function () {
            return $(this).find('li').length > 10
             }).append('<li class="showMore">Show More</li>');
         
         $('.tag-list li:nth-child(10)').nextAll('li').hide();
         
         $('.showMore').click(function(){
           $(this).siblings('.tag-list li:nth-child(10)').nextAll('li').slideToggle('slow');
           $(this).text(function(i, text){
                return text === "Show More" ? "Show Less" : "Show More";
            });
         });
        */

        // Pause/Play Video Feature
        $('.videoPause').click(function() {
            $('video').trigger('pause');
        });
        $('.videoPlay').click(function() {
            $('video').trigger('play');
        });

        // Zoom Banner
        $(".premium-banner img, .premium-banner-content, .parallax-banner, .collection-hero").addClass("loaded");

        // Sizing Chart Popup
        $('.size-chart-button').click(function (){
          $('.size-chart-overlay').fadeIn(500);
          $('.size-chart-popup').fadeIn(500);
          $('body').addClass('locked');
        });
        $('.size-chart-close-button, .size-chart-overlay').click(function (){
          $('.size-chart-overlay').fadeOut(300);
          $('.size-chart-popup').fadeOut(300);
          $('body').removeClass('locked');
        });

      // Open new window outgoing URLs, ignoring snow blocks and sso links 
      $('a:not(.snowBlockLink, .quick-view, .csb-link, .same-tab-link, .logout-link, .section--contact-information, .learn-more-edd, .edd-exceptions)').attr('target', function() {
          if(this.host == location.host) 
            return '_self'
          else 
            return '_blank'
      });

    });
})(jQuery);